import * as React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

interface Props extends MaskedInputProps {
  /** Ref used by containing input component */
  inputRef: (ref: HTMLInputElement | null) => void;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    '&::placeholder': {
      color: 'black',
      opacity: '1'
    }
  }
});

/**
 * Mask for phone number inputs showing guides in format `(555) 555-5555`. To be used as the component in an OutlinedInput as `InputProps={{ inputComponent: PhoneInputMask as any }}`
 */
const PhoneInputMask = (props: Props) => {
  const { inputRef, className, ...other } = props;
  const classes = useStyles();

  return (
    <MaskedInput
      {...other}
      ref={(ref: any) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholder={'(\u2000\u2000\u2000) \u2000\u2000\u2000-\u2000\u2000\u2000\u2000'}
      placeholderChar={'\u2000'}
      className={clsx(classes.root, className)}
    />
  );
};

export default PhoneInputMask;
